const branches = [
    {
        "id": 1,
        "uid": "20250412095320137",
        "lat": 17.7268874,
        "lng": 83.3023793,
        "location": "HEAD OFFICE & ADMIN OFFICE",
        "address": "D.No. 47-10-13, 1st Floor, Rednam Plaza, 2nd Lane, Dwarakanagar, VISAKHAPATNAM – 530 016, Andhra Pradesh",
        "tel": [
            "0891 6661277",
            "9951001277",
            "9951001377"
        ],
        "fax": "0891 6661577",
        "email": [
            "sales@pbltransport.co.in"
        ]
    },
    {
        "id": 2,
        "uid": "20250412095320292",
        "lat": 13.090484,
        "lng": 80.238463,
        "location": "CHENNAI BRANCH",
        "address": "17A – Second Floor, Opp. Hotel Vijay Park, 200 feet road, Ponni amma medu, Madhavaram, Chennai – 600 110, TAMIL NADU",
        "tel": [
            "044 42824172",
            "9182053450",
            "9840072577"
        ],
        "email": [
            "am3@pbltransport.co.in",
            "RM1@pbltransport.co.in"
        ]
    },
    {
        "id": 3,
        "uid": "20250412095320458",
        "lat": 19.182466,
        "lng": 72.977679,
        "location": "MUMBAI BRANCH",
        "address": "Sai Om Co-Operative Housing Society 1st Floor, Room No 7, Louis Wadi (Kajuwadi), Near Nitin Company, Thane West, MUMBAI – 400 099, Maharashtra",
        "email": [
            "mumbai@pbltransport.co.in"
        ]
    },
    {
        "id": 4,
        "uid": "20250412095320549",
        "lat": 17.711907,
        "lng": 83.155318,
        "location": "GAJUWAKA BRANCH",
        "address": "Plot No. 166, A/E-Peda Gantyada",
        "tel": [
            "9848029577"
        ],
        "email": [
            "gwk@pbltransport.co.in"
        ]
    },
    {
        "id": 5,
        "uid": "20250412095320677",
        "lat": 17.411695,
        "lng": 78.476801,
        "location": "HYDERABAD BRANCH",
        "address": "D.No-1-1-65/12, Near Ratnadeep Super Market HP Gas Office, Near APT 1st Floor I Square Residency, Ameerpet, HYDERABAD – 500 016",
        "tel": [
            "9848193277"
        ],
        "email": [
            "hydmktg@pbltransport.co.in"
        ]
    },
    {
        "id": 6,
        "uid": "20250412095320721",
        "lat": 16.990487,
        "lng": 82.238787,
        "location": "KAKINADA BRANCH",
        "address": "ADB Road, Near Sai Nagar, 1st Street, Bank Colony, Vakalapudi (Post) KAKINADA – 533 004",
        "tel": [
            "0884 2306377",
            "9848046377"
        ],
        "email": [
            "am2@pbltransport.co.in"
        ]
    },
    {
        "id": 7,
        "uid": "20250412095320860",
        "lat": 18.520393,
        "lng": 73.856746,
        "location": "PUNE BRANCH",
        "address": "Shop no-7, Ground Floor, Morya Business Centre, APT GP 115, G Block, Sambhaji Nagar, Chinchwada, PUNE 411019",
        "tel": [
            "6303804247",
            "6305218363"
        ],
        "email": [
            "pune.sales@pbltransport.co.in",
            "operation.pune@pbltransport.co.in"
        ]
    },
    {
        "id": 8,
        "uid": "20250412095320914",
        "lat": 17.012684,
        "lng": 81.797423,
        "location": "RAJAHMUNDRY BRANCH",
        "address": "D. No, 4-89/2, Workers Colony, Near Menaka Hotel, Lala Cheruvu, RAJAMUNDRY – 533 106, Andhra Pradesh",
        "email": [
            "sales@pbltransport.co.in"
        ]
    },
    {
        "id": 9,
        "uid": "20250412095320082",
        "lat": 17.822624,
        "lng": 83.006879,
        "location": "LANKELAPALEM BRANCH (GARAGE)",
        "address": "Survey No:178/2, Nh-5 Road, LANKELAPALEM, Paravada Mandalam, Visakhapatnam (Dist)-531019, Andhra Pradesh",
        "tel": [
            "9848603677"
        ],
        "email": [
            "fleet@pbltransport.co.in"
        ]
    }
];
export default branches;